import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kandivalitoopunecab() {



  const cardData = {


   keyword: "Kandivali to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Kandivali to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a comfortable journey from Kandivali to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Kandivali to Pune taxi services.",

  topPlaces: [
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's leading IT and business hubs, featuring EON IT Park, multinational companies, corporate offices, and modern commercial spaces. It is a preferred destination for professionals and corporate travelers."
    },
    {
      title: "Wagholi",
      description: "Wagholi is a rapidly developing Pune suburb known for residential projects, commercial developments, educational institutions, and easy connectivity to Kharadi and major business areas."
    },
    {
      title: "Pimple Saudagar",
      description: "Pimple Saudagar is a well-developed residential and commercial locality offering premium housing projects, restaurants, shopping areas, and convenient access to Pimpri Chinchwad and Pune IT corridors."
    },
    {
      title: "Wakad",
      description: "Wakad is a growing suburb near Hinjewadi known for IT professionals, commercial complexes, residential projects, and excellent connectivity to Pune's major business destinations."
    },
    {
      title: "Chakan Industrial Area",
      description: "Chakan Industrial Area is a major manufacturing and logistics hub near Pune, housing automobile companies, engineering industries, warehouses, and large industrial facilities."
    },
    {
      title: "Hadapsar",
      description: "Hadapsar is an important commercial and residential destination featuring Magarpatta City, IT companies, business parks, educational institutions, and excellent connectivity across Pune."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous cultural landmarks, attracting devotees and tourists with its rich heritage, spiritual importance, and grand celebrations."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic Pune monument known for its beautiful architecture and association with India's freedom movement. It is a popular sightseeing destination for tourists and history lovers."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and lush green valleys. It is a popular weekend getaway for travelers."
    },
    {
      title: "Bhushi Dam",
      description: "Bhushi Dam near Lonavala is a famous monsoon attraction known for flowing water, scenic surroundings, and a refreshing natural atmosphere. It attracts tourists and families throughout the year."
    }
  ],






"services": [
  {
    "name": "Kandivali to Pune Cab Fare",
    "description": "Check Kandivali to Pune Cab Fare with affordable pricing, comfortable AC vehicles, professional drivers, and transparent charges for one-way and outstation travel."
  },
  {
    "name": "Kandivali to Pune Station Cab Fare",
    "description": "Book Kandivali to Pune Station Cab Fare service with reliable pickup, clean cars, experienced chauffeurs, and convenient travel options."
  },
  {
    "name": "Kandivali to Pune Pimpri Chinchwad Cab Fare",
    "description": "Get Kandivali to Pune Pimpri Chinchwad Cab Fare with fixed pricing, premium vehicles, and comfortable intercity transportation."
  },
  {
    "name": "Kandivali to Baner Taxi Fare",
    "description": "Check Kandivali to Baner Taxi Fare for affordable travel with professional drivers, AC cars, and reliable cab service."
  },
  {
    "name": "Kandivali to Pune by Taxi",
    "description": "Travel from Kandivali to Pune by Taxi with experienced chauffeurs, multiple vehicle options, doorstep pickup, and smooth highway journeys."
  },
  {
    "name": "Kandivali to Pune One Way Taxi Fare",
    "description": "Book Kandivali to Pune One Way Taxi Fare service with transparent rates, direct drop facility, and comfortable travel."
  },
  {
    "name": "Kandivali to Pune Kondhwa Taxi",
    "description": "Choose Kandivali to Pune Kondhwa Taxi for safe intercity travel with clean vehicles and professional drivers."
  },
  {
    "name": "Kandivali to Pune Innova Crysta Cab",
    "description": "Hire Kandivali to Pune Innova Crysta Cab for family and group travel with spacious seating, premium comfort, and experienced chauffeurs."
  },
  {
    "name": "Kandivali to Pune Kharadi Cab",
    "description": "Book Kandivali to Pune Kharadi Cab with reliable service, affordable fares, comfortable cars, and timely pickup."
  },
  {
    "name": "Kandivali to Swargate Cab",
    "description": "Reserve Kandivali to Swargate Cab for convenient transportation with AC vehicles, professional drivers, and flexible booking."
  },
  {
    "name": "Taxi Service in Kandivali Mumbai",
    "description": "Get Taxi Service in Kandivali Mumbai for local and outstation travel with clean vehicles, experienced chauffeurs, and affordable pricing."
  },
  {
    "name": "Kandivali to Pune Ertiga Taxi Fare",
    "description": "Check Kandivali to Pune Ertiga Taxi Fare for spacious family travel with comfortable seating and transparent charges."
  },
  {
    "name": "Mumbai to Pune Taxi Fare",
    "description": "Find Mumbai to Pune Taxi Fare with affordable packages, premium cars, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Pune Car Rental",
    "description": "Choose Mumbai to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for comfortable journeys."
  },
  {
    "name": "Mumbai to Pune Cab Charges",
    "description": "Check Mumbai to Pune Cab Charges with transparent billing, no hidden costs, and multiple vehicle choices."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Complete Mumbai to Pune Cab Booking online with instant confirmation, professional drivers, and comfortable travel options."
  },
  {
    "name": "Cab Service in Mumbai",
    "description": "Book Cab Service in Mumbai for airport transfers, outstation trips, corporate travel, and personal journeys."
  },
  {
    "name": "Cab Booking Mumbai",
    "description": "Reserve Cab Booking Mumbai with easy online booking, affordable fares, and reliable taxi services."
  },
  {
    "name": "Mumbai Taxi Service",
    "description": "Choose Mumbai Taxi Service with experienced drivers, clean AC vehicles, and dependable transportation."
  },
  {
    "name": "Cheapest Cab Service in Mumbai",
    "description": "Book Cheapest Cab Service in Mumbai with budget-friendly rates, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Taxi Service in Kandivali",
    "description": "Get Taxi Service in Kandivali with safe travel options, premium cars, and quick booking support."
  },
  {
    "name": "Cab Service in Kandivali",
    "description": "Choose Cab Service in Kandivali for reliable local and outstation travel with professional drivers."
  },
  {
    "name": "Kandivali to Outstation Cab Service",
    "description": "Book Kandivali to Outstation Cab Service for long-distance journeys with comfortable vehicles and experienced chauffeurs."
  },
  {
    "name": "Kandivali to Pune Cab",
    "description": "Book Kandivali to Pune Cab for safe intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and premium cars."
  },
  {
    "name": "Kandivali to Pune Taxi",
    "description": "Choose Kandivali to Pune Taxi with affordable fares, clean AC vehicles, and reliable transportation."
  },
  {
    "name": "Kandivali to Pune Cab Service",
    "description": "Reserve Kandivali to Pune Cab Service with doorstep pickup, professional drivers, and smooth travel experience."
  },
  {
    "name": "Kandivali to Pune One Way Cab",
    "description": "Book Kandivali to Pune One Way Cab for direct travel with fixed fares and comfortable vehicles."
  },
  {
    "name": "Kandivali to Pune Taxi Booking",
    "description": "Complete Kandivali to Pune Taxi Booking online with multiple vehicle options and instant confirmation."
  },
  {
    "name": "Kandivali to Pune Drop Taxi",
    "description": "Choose Kandivali to Pune Drop Taxi for affordable one-way travel with reliable service."
  },
  {
    "name": "Kandivali to Pune Online Cab Booking",
    "description": "Use Kandivali to Pune Online Cab Booking for quick reservation, transparent pricing, and professional drivers."
  },
  {
    "name": "Kandivali to Pune Private Cab",
    "description": "Hire Kandivali to Pune Private Cab for exclusive travel with privacy, comfort, and flexible schedules."
  },
  {
    "name": "Kandivali to Pune Outstation Cab",
    "description": "Book Kandivali to Pune Outstation Cab for safe highway journeys with premium vehicles and trained chauffeurs."
  },
  {
    "name": "Kandivali to Pune Cheap Cab",
    "description": "Choose Kandivali to Pune Cheap Cab with affordable pricing and dependable intercity transportation."
  },
  {
    "name": "Kandivali to Pune AC Cab Service",
    "description": "Travel comfortably with Kandivali to Pune AC Cab Service featuring clean air-conditioned cars and professional drivers."
  },
  {
    "name": "Kandivali to Pune Innova Cab",
    "description": "Book Kandivali to Pune Innova Cab for family trips with spacious seating and premium comfort."
  },
  {
    "name": "Kandivali to Pune Taxi Fare",
    "description": "Check Kandivali to Pune Taxi Fare with transparent rates and flexible travel packages."
  },
  {
    "name": "Kandivali East to Pune Cab",
    "description": "Reserve Kandivali East to Pune Cab with reliable pickup and comfortable AC vehicles."
  },
  {
    "name": "Kandivali West to Pune Cab",
    "description": "Choose Kandivali West to Pune Cab for safe travel with experienced chauffeurs and affordable fares."
  }
],

"tableData": [
  ["Kandivali to Pune Cab Fare", "Kandivali to Pune Station Cab Fare"],
  ["Kandivali to Pune Pimpri Chinchwad Cab Fare", "Kandivali to Baner Taxi Fare"],
  ["Kandivali to Pune by Taxi", "Kandivali to Pune One Way Taxi Fare"],
  ["Kandivali to Pune Kondhwa Taxi", "Kandivali to Pune Innova Crysta Cab"],
  ["Kandivali to Pune Kharadi Cab", "Kandivali to Swargate Cab"],
  ["Taxi Service in Kandivali Mumbai", "Kandivali to Pune Ertiga Taxi Fare"],
  ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
  ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Booking"],
  ["Cab Service in Mumbai", "Cab Booking Mumbai"],
  ["Mumbai Taxi Service", "Cheapest Cab Service in Mumbai"],
  ["Kandivali to Outstation Cab Service", "Kandivali to Pune Cab"],
  ["Kandivali to Pune Taxi", "Kandivali to Pune Cab Service"],
  ["Kandivali to Pune One Way Cab", "Kandivali to Pune Taxi Booking"],
  ["Kandivali to Pune Drop Taxi", "Kandivali to Pune Online Cab Booking"],
  ["Kandivali to Pune Private Cab", "Kandivali to Pune Outstation Cab"],
  ["Kandivali to Pune Cheap Cab", "Kandivali to Pune AC Cab Service"],
  ["Kandivali to Pune Innova Cab", "Kandivali to Pune Taxi Fare"],
  ["Kandivali East to Pune Cab", "Kandivali West to Pune Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Kandivali to Pune Cab Service",
    WhyChoosedescription: "Trustline Travels offers comfortable Kandivali to Pune cab services with professional drivers, clean vehicles, and dependable travel solutions for every journey."
  },
  {
    WhyChooseheading: "Convenient Pickup from Kandivali",
    WhyChoosedescription: "Get doorstep pickup from Kandivali East, Kandivali West, railway station, offices, hotels, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Smooth Mumbai Pune Travel",
    WhyChoosedescription: "Our experienced chauffeurs ensure a secure and comfortable journey with excellent knowledge of the Mumbai-Pune route."
  },
  {
    WhyChooseheading: "Vehicles for Individual & Group Travel",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger and luggage requirements."
  },
  {
    WhyChooseheading: "Transparent Kandivali Pune Cab Pricing",
    WhyChoosedescription: "Enjoy competitive fares with clear pricing details and no hidden charges before confirming your cab booking."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Facility",
    WhyChoosedescription: "Select one-way cabs, return journeys, or customized travel plans according to your schedule and destination preferences."
  },
  {
    WhyChooseheading: "Ideal for Airport, Corporate & Family Travel",
    WhyChoosedescription: "Our Kandivali to Pune cabs are suitable for Mumbai Airport transfers, business trips, family journeys, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Cab Availability & Support",
    WhyChoosedescription: "Book your cab anytime with quick assistance, instant confirmation, and reliable support throughout your travel."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Kandivali to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Kandivali to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Kandivali to Pune?",
    answer: "Yes, one-way cab booking is available from Kandivali to Pune with convenient pickup and drop options."
  },
  {
    question: "Do you provide pickup from Kandivali East and Kandivali West?",
    answer: "Yes, pickup is available from Kandivali East, Kandivali West, and nearby Mumbai locations."
  },
  {
    question: "Which cars are available for Kandivali to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a Kandivali to Pune cab for Mumbai Airport transfer?",
    answer: "Yes, we provide airport transfer cabs from Kandivali and Mumbai Airport areas to Pune."
  },
  {
    question: "Is Kandivali to Pune cab service available 24 hours?",
    answer: "Yes, our cab service operates 24/7 for convenient travel at any time."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking fare."
  },
  {
    question: "Can I book my Kandivali to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide Kandivali to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate meetings, employee travel, and professional transportation needs."
  },
  {
    question: "How can I book Kandivali to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Manish Rane",
    feedback: "Trustline Travels provided an excellent Kandivali to Pune travel experience with timely pickup, comfortable seating, and a professional driver. The journey was smooth and relaxing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shreya Patil",
    feedback: "The cab service was very convenient with easy coordination, a clean vehicle, and safe driving. Trustline Travels made our journey from Kandivali to Pune comfortable and hassle-free.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kandivali to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/kandivali-to-pune-cab.webp",
  "description":
    "Book Kandivali to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cab services from Kandivali to Pune, Pimpri Chinchwad, Baner, Kondhwa, Pune Railway Station, and other Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/kandivali-to-pune-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Kandivali to Pune Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Kandivali to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Travel comfortably from Kandivali to Pune, Pimpri Chinchwad, Baner, Kondhwa, Pune Railway Station, and nearby locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Kandivali to pune cab fare, kandivali to pune station cab fare, kandivali to pune pimpri chinchwad cab fare, kandivali to baner taxi fare, kandivali to pune by taxi, kandivali to pune one way taxi fare, kandivali to pune kondhwa taxi, kandivali to pune innova crysta cab, Kandivali to Pune Cab, Kandivali Pune Taxi Service, Kandivali to Pune Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kandivalitoopunecab;